/**
 * Formateo consistente de moneda ecuatoriana.
 * Siempre devuelve el formato $X.XXX,XX (punto para miles, coma para decimales),
 * independiente del locale del navegador.
 */
export function fmtCurrency(n) {
  const num = Number(n || 0);
  const fixed = Math.abs(num).toFixed(2); // "1234.50"
  const [intPart, decPart] = fixed.split(".");
  // Inserta punto como separador de miles
  const withDots = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  const sign = num < 0 ? "-" : "";
  return `${sign}$${withDots},${decPart}`;
}

/** Formato sin símbolo (para inputs numéricos). */
export function fmtNumber(n) {
  const num = Number(n || 0);
  return num.toLocaleString("es-EC", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}
